// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fk-7";
export var emphasizeQuantity = "_fk-3";
export var flatBottomCorners = "_fk-5";
export var productImage = "_fk-0";
export var quantityContainer = "_fk-2";
export var quantityHeader = "_fk-6";
export var tooltip = "_fk-1";
export var wrapAndEllipsesOverflow = "_fk-4";